
export default {
  name: 'CategoryPage',
  async asyncData({ $db, params }) {
    const category = await $db.fetch('categoryBySlug', { slug: params.slug })
    const rawCategories = await $db.fetch('categories')
    return {
      category,
      categories: rawCategories.filter((c) => c.name !== category.name),
      subs: await $db.fetch('categoriesBy', {
        key: 'parent',
        param: category.name
      }),
      products: await $db.fetch('productsBy', {
        key: 'category',
        param: category.name
      })
    }
  },
  data: () => ({
    displayCategories: false,
    displaySubs: false,
    subFilter: ''
  }),
  computed: {
    filteredProducts() {
      if (!this.subFilter) return this.products
      return this.products.filter((p) =>
        p.subCategories.includes(this.subFilter)
      )
    }
  },
  methods: {
    updateFilter(name) {
      this.subFilter = name
    }
  },
  head() {
    return {
      title: this.category.name
    }
  }
}
